var path = 'audit/audit-log-header.tpl.html';
var html = " <div translate class=tb-cell flex=30>audit-log.timestamp</div> <div ng-if=\"auditLogMode != types.auditLogMode.entity\" translate class=tb-cell flex=10>audit-log.entity-type</div> <div ng-if=\"auditLogMode != types.auditLogMode.entity\" translate class=tb-cell flex=30>audit-log.entity-name</div> <div ng-if=\"auditLogMode != types.auditLogMode.user\" translate class=tb-cell flex=30>audit-log.user</div> <div translate class=tb-cell flex=15>audit-log.type</div> <div translate class=tb-cell flex=15>audit-log.status</div> <div translate class=tb-cell flex=10>audit-log.details</div> ";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ./src/app/audit/audit-log-header.tpl.html
// module id = 1383
// module chunks = 1